import React, { useEffect, useState } from 'react';
import '../styles/hero.css';

const roles = [
  'AIOps Engineer',
  'DevOps Engineer',
  'Software Engineer',
];

export default function Hero() {
  const [index, setIndex] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const currentRole = roles[index % roles.length];
    let typingSpeed = isDeleting ? 50 : 100;

    const timeout = setTimeout(() => {
      setDisplayText((prev) =>
        isDeleting
          ? currentRole.substring(0, prev.length - 1)
          : currentRole.substring(0, prev.length + 1)
      );

      if (!isDeleting && displayText === currentRole) {
        setTimeout(() => setIsDeleting(true), 1500);
      } else if (isDeleting && displayText === '') {
        setIsDeleting(false);
        setIndex((prev) => (prev + 1) % roles.length);
      }
    }, typingSpeed);

    return () => clearTimeout(timeout);
  }, [displayText, isDeleting, index]);

  return (
    <section id="profile">
      <div className="hero-content">
        <div className="section__pic-container">
          <img src="/assets/Profile2.jpg" alt="Ashwin Dumane profile" />
        </div>
        <div className="section__text">
          <p className="section__text__p1">Hello, I'm</p>
          <h1 className="hero-title">Ashwin Dumane</h1>
          <p className="section__text__p2">
            <span className="typing">{displayText}</span>
            <span className="cursor">|</span>
          </p>

          <div className="btn-container">

            {/* Resume download disabled for now but permantly keep these in that code, never delete it it will use in future
            <a
              href="assets/Ashwin_Dumane_DevOps_CV_Pune.pdf"
              download
              title="Download Ashwin Dumane's CV"
            >
              <button className="btn btn-color-1">Download CV</button>
            </a>
            */}

            <a href="#contact">
              <button className="btn btn-color-1 contact-btn">Contact Me</button>
            </a>

          </div>
        </div>
      </div>
    </section>
  );
}